export default __webpack_public_path__ + "static/media/remove-black-sm.acd862ab.svg";